import { qoursesApi } from '@/api/qourses.tsx'
import { useQuery } from '@tanstack/react-query'
import { PublicMediaGalleryItemEntity } from '../../../qourses-api-client'

export default function useGetMediaGalleryItemsPublic(organizationId: string): {
  mediaGalleryItems: PublicMediaGalleryItemEntity[]
  isLoading: boolean
  isEmptyMediaImages: boolean
  isError: boolean
  refetch: () => void
  isRefetching: boolean
} {
  const {
    data: mediaGalleryItems,
    isLoading,
    isError,
    refetch,
    isRefetching,
  } = useQuery(
    getMediaGalleryItemsQueryKey(organizationId),
    async () => {
      return qoursesApi.organizationPublic.organizationPublicControllerGetPublicOrganizationMediaGalleryItemsV1(
        organizationId,
      )
    },
    {
      enabled: !!organizationId,
    },
  )

  const isEmpty = !mediaGalleryItems || mediaGalleryItems.length === 0

  return {
    mediaGalleryItems: mediaGalleryItems || [],
    isLoading,
    isEmptyMediaImages: isEmpty,
    isError,
    refetch,
    isRefetching,
  }
}

export const getMediaGalleryItemsQueryKey = (organizationId: string) => [
  'public',
  'mediaGalleryItems',
  organizationId,
]
